// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkboxContainer_xRD7O {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--_2-color);
  font-size: 13px;
  label {
    cursor: pointer;
    margin: 0;
  }
}

.checkboxContainer_xRD7O input[type="checkbox"] {
  accent-color: var(--_10a37f-background);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CustomCheckboxWithLabel/CustomCheckboxWithLabel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,eAAe;EACf;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE,uCAAuC;AACzC","sourcesContent":[".checkboxContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--_2-color);\n  font-size: 13px;\n  label {\n    cursor: pointer;\n    margin: 0;\n  }\n}\n\n.checkboxContainer input[type=\"checkbox\"] {\n  accent-color: var(--_10a37f-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxContainer": `checkboxContainer_xRD7O`
};
export default ___CSS_LOADER_EXPORT___;
